import { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { MyContext } from "../../../hooks/MyContextProvider";
import Logo from "../../../assets/images/Logo-bg.png";
import LogoWhite from "../../../assets/images/Logo-white.png";
import smallLogo from "../../../assets/images/small-logo.png";
import { sidebarData } from "../../../hooks/helper";

const MobileSidebar = () => {
  const { theme, isMenuExpanded, setIsMenuExpanded } = useContext(MyContext);
  const [activeMenu, setActiveMenu] = useState(null);
  const location = useLocation();
  return (
    <aside
      id="layout-menu"
      class="layout-menu menu menu-vertical null"
      style={{
        touchAction: "none",
        userSelect: "none",
        WebkitUserDrag: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      }}
    >
      <div class="d-flex h-100 container-fluid flex-column p-0">
        <Link class="menu-horizontal-prev d-none"></Link>
        <div class="navbar-brand app-brand demo d-xl-flex py-0 me-4 ms-0">
          <Link to="/administration" class="app-brand-link">
            <span class="app-brand-logo demo">
              <span class="text-primary">
                <img
                  src={theme === "dark" ? LogoWhite : Logo}
                  alt="Logo"
                  height="30"
                />
              </span>
            </span>
          </Link>

          <Link
            onClick={() => setIsMenuExpanded(!isMenuExpanded)}
            class="layout-menu-toggle menu-link text-large ms-auto d-xl-none"
          >
            <i class="icon-base ti tabler-x icon-sm d-flex align-items-center justify-content-center"></i>
          </Link>
        </div>
        <ul
          class="sidebar-menu-cus menu-inner ps ps--active-y overflow-auto"
          style={{ marginLeft: "0px" }}
        >
          {/* <!-- Dashboards --> */}
          {sidebarData.map((item) => (
            <li
              class={`menu-item ${
                location.pathname === item?.link ? "active" : ""
              } ${activeMenu === item?.id ? "open" : ""}`}
            >
              {item.subMenu.length > 0 ? (
                <Link
                  onClick={() =>
                    setActiveMenu(activeMenu === item?.id ? null : item?.id)
                  }
                  class="menu-link menu-toggle"
                >
                  <i class={`menu-icon icon-base  ${item?.icon}`}></i>
                  <div data-i18n={item?.id}>{item.title}</div>
                </Link>
              ) : (
                <Link to={item.link} class="menu-link">
                  <i class={`menu-icon icon-base  ${item?.icon}`}></i>
                  <div data-i18n={item?.id}>{item.title}</div>
                </Link>
              )}
              {item.subMenu.length > 0 && (
                <ul class="menu-sub">
                  {item.subMenu.map((subItem) => (
                    <li
                      class={`menu-item ${
                        location.pathname === subItem?.link ? "active" : ""
                      }`}
                    >
                      <Link to={subItem.link} class="menu-link">
                        <i class="menu-icon icon-base ti tabler-chart-pie-2"></i>
                        <div data-i18n="Analytics">{subItem.title}</div>
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}

          <div class="ps__rail-x" style={{ left: "0px", bottom: "0px" }}>
            <div
              class="ps__thumb-x"
              tabindex="0"
              style={{ left: "0px", width: "0px" }}
            ></div>
          </div>
          <div
            class="ps__rail-y"
            style={{ top: "0px", height: "227px", right: "4px" }}
          >
            <div
              class="ps__thumb-y"
              tabindex="0"
              style={{ top: "0px", height: "130px" }}
            ></div>
          </div>
        </ul>
        <div class="menu-horizontal-wrapper"></div>
        <a href="#" class="menu-horizontal-next d-none"></a>
      </div>
    </aside>
  );
};

export default MobileSidebar;
